import { EVENT_NAMES, useAnalytics } from '@web-app/context/AnalyticsContext';
import { useCallback } from 'react';

export type CalendarActionEvent = {
  action: 'create' | 'update' | 'delete' | 'view';
  entityType: 'appointment' | 'block' | 'availability' | 'calendar';
  appointmentId?: string;
  previousAppointmentId?: string;
  patientId?: string;
  appointmentTypeId?: string;
  datetime?: string;
  mode?: 'book' | 'reschedule';
  lateCancel?: boolean;
  groupId?: string;
  availabilityId?: string;
  dayOfWeek?: number;
  daysOfWeek?: string;
  startTime?: string;
  endTime?: string;
  startOn?: string;
  endOn?: string;
  scope?: 'all' | 'thisAndFuture' | 'this';
  occurrenceDate?: string;
  applyToFollowUp?: boolean;
  partial?: boolean;
  timezone?: string;
};

export function useCalendarAction() {
  const { trackEvent } = useAnalytics();
  return useCallback(
    (event: CalendarActionEvent) =>
      trackEvent(EVENT_NAMES.CALENDAR_ACTION, event),
    [trackEvent],
  );
}
